let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fN0tk")).then(() => parcelRequire('6jLzu'));